
import EDCaptionedValue from '../../../../../../BaseComponents/CaptionedValue/EDCaptionedValue';
import EDTypography from '../../../../../../BaseComponents/Typography/EDTypography';
import { StatistikrapporteringQuery_node_TEDBOAktivitet } from '../Queries/_QueryTypes/StatistikrapporteringQuery';
import { alderInitAntal } from '../Utils/Counters';

interface IProps {
  statNodeData:
    | StatistikrapporteringQuery_node_TEDBOAktivitet
    | null
    | undefined;
  alderId: string;
  alderBenamning: string;
}

export const StatAlderValue: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const value =
    props.statNodeData && alderInitAntal(props.statNodeData, props.alderId);
  return (
    <EDCaptionedValue
      label={props.alderBenamning}
      name={props.alderId}
      size="large"
    >
      <EDTypography variant="body1">{value}</EDTypography>
    </EDCaptionedValue>
  );
};
